import { FormattedMessage } from 'react-intl';
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import ContainerOutlined from '@ant-design/icons/ContainerOutlined';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import BugOutlined from '@ant-design/icons/BugOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import CodeOutlined from '@ant-design/icons/CodeOutlined';
import CrownOutlined from '@ant-design/icons/CrownOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import DesktopOutlined from '@ant-design/icons/DesktopOutlined';
import KeyOutlined from '@ant-design/icons/KeyOutlined';
import AuditOutlined from '@ant-design/icons/AuditOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import type { NavItemType } from 'types/menu';

const pageHome: NavItemType = {
  id: 'home',
  title: <FormattedMessage id="home" />,
  type: 'item',
  icon: DashboardOutlined,
  url: '/',
};

const pentestsPage: NavItemType = {
  id: 'pentest',
  title: <FormattedMessage id="pentests" />,
  type: 'item',
  icon: BugOutlined,
  url: '/pentest',
};

const adminPages: NavItemType = {
  id: 'group-pages',
  title: <FormattedMessage id="pages" />,
  type: 'group',
  children: [
    pageHome,
    pentestsPage,
    { id: 'company', title: <FormattedMessage id="companies" />, type: 'item', icon: ApartmentOutlined, url: '/company' },
    {
      id: 'users',
      title: 'Users',
      type: 'collapse',
      icon: TeamOutlined,
      children: [
        { id: 'user', title: 'Customers', type: 'item', icon: UserOutlined, url: '/user' },
        { id: 'pentester', title: <FormattedMessage id="pentesters" />, type: 'item', icon: CodeOutlined, url: '/pentester' },
        {
          id: 'administrators',
          title: <FormattedMessage id="administrators" />,
          type: 'item',
          icon: CrownOutlined,
          url: '/admin',
          matchEnd: true,
          activePaths: ['/admin', '/admin/new'],
        },
      ],
    },
    {
      id: 'security',
      title: 'Security',
      type: 'collapse',
      icon: SafetyCertificateOutlined,
      children: [
        { id: 'admin-sessions', title: 'Account Sessions', type: 'item', icon: DesktopOutlined, url: '/admin/sessions' },
        { id: 'company-access', title: 'Company Access', type: 'item', icon: KeyOutlined, url: '/admin/companies/access-status' },
        { id: 'audit-events', title: 'Audit Event', type: 'item', icon: AuditOutlined, url: '/admin/audit-events' },
      ],
    },
    { id: 'report-templates', title: <FormattedMessage id="report-templates" />, type: 'item', icon: FileTextOutlined, url: '/template' },
  ],
};

const pentesterPages: NavItemType = {
  id: 'group-pages',
  title: <FormattedMessage id="pages" />,
  type: 'group',
  children: [
    { ...pageHome, icon: HomeOutlined },
    { ...pentestsPage, icon: ContainerOutlined },
  ],
};

const customerPages: NavItemType = {
  id: 'group-pages',
  title: <FormattedMessage id="pages" />,
  type: 'group',
  children: [pageHome, pentestsPage, { id: 'user', title: 'Users', type: 'item', icon: TeamOutlined, url: '/company/settings' }],
};

export default { adminPages, pentesterPages, customerPages };
